// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2lOWl","dragIcon":"SortableItem_dragIcon__1yIGL","disabled":"SortableItem_disabled__2Sjr9"};